import { Participant } from '../models';
import { ParticipantRepository } from '../repositories';

export class GetParticipantsByTournamentUseCase {
  constructor(private participantRepository: ParticipantRepository) {}

  async execute(tournamentId: string): Promise<Participant[]> {
    return await this.participantRepository.getByTournamentId(tournamentId);
  }
}
